export const getIdFromUrl =
  (url: string) =>
  (type: "site" | "company", typeIndex: number, returnIndex: number) => {
    const splittedUrl = url.split("/");

    if (splittedUrl[typeIndex] === type && splittedUrl[returnIndex]) {
      return type === "site"
        ? parseInt(splittedUrl[returnIndex])
        : splittedUrl[returnIndex];
    }

    return null;
  };
